<template>
  <div id="overlay-info" v-show="showContent" v-on:click.self="closeModal">
    <div id="content" class="action-close">
      <div id="app" class="contact">
        <h2>お問い合わせ</h2>
        <p>
          不具合報告やご要望をこちらから送信できます。
          なお、特別な場合を除いて返信はいたしません。何卒ご了承ください。<br>
          <br>
          * は必須項目です
        </p>
        <form class="contact-form" method="post" action="">
          <table>
            <tbody>
            <tr>
              <th>種別 *</th>
              <td nowrap="">
                <input type="radio" id="bug" value='1' v-model="type" style="width: auto">
                <label for="bug">不具合報告</label>
                <br>
                <input type="radio" id="request" value='2' v-model="type" style="width: auto">
                <label for="request">要望</label>
                <br>
                <input type="radio" id="others" value='100' v-model="type" style="width: auto">
                <label for="others">その他</label>
              </td>
            </tr>
            <tr>
              <th>件名 *</th>
              <td>
                <input type="text" v-model="title" placeholder="例）○○機能が欲しい <20文字以内>">
                <p class="error">{{ errors.title }}</p>
              </td>
            </tr>
            <tr>
              <th>内容 *</th>
              <td>
                <textarea cols="50" rows="8" v-model="body" placeholder="例）△△について○○できる機能が欲しいです <1000文字以内>"></textarea>
                <p class="error">{{ errors.body }}</p>
              </td>
            </tr>
            <tr>
              <th>お名前</th>
              <td>
                <input v-model="name" placeholder="例）リシュリュー">
                <p class="error">{{ errors.name }}</p>
              </td>
            </tr>
            <tr>
              <th>メールアドレス</th>
              <td>
                <input type="email" v-model="email" placeholder="例）info@example.co.jp">
                <p class="error">{{ errors.email }}</p>
              </td>
            </tr>
            </tbody>
          </table>
          <button v-if="!valid" :disabled="!valid" type="button">入力項目をお確かめください</button>
          <button v-else-if="valid" type="button" @click="submit">送信</button>
        </form>
      </div>
      <button class="btn" v-on:click="closeModal">×</button>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'

const axios = process.env.NODE_ENV === 'development'
  ? require('axios').create({ baseURL: 'http://localhost:3000' })
  : require('axios').create()

export default {
  data: function () {
    return {
      type: '100',
      title: '',
      body: '',
      name: '',
      email: '',
      result: ''
    }
  },
  computed: {
    checkName: function () {
      // if (!this.name) {
      //   return 'お名前を入力してください'
      // }
      return ''
    },
    checkTitle: function () {
      if (!this.title) {
        return '件名を入力してください'
      } else if (!this.validTitle(this.title)) {
        return '件名を20文字以内で入力してください'
      }
      return ''
    },
    checkBody: function () {
      if (!this.body) {
        return '内容を入力してください'
      } else if (!this.validBody(this.body)) {
        return '内容を1000文字以内で入力してください'
      }
      return ''
    },
    checkEmail: function () {
      if (!this.email) {
        return ''
      } else if (!this.validEmail(this.email)) {
        return 'メールアドレスを正しく入力してください'
      }
      return ''
    },
    errors: function () {
      const errors = {
        'title': this.checkTitle,
        'body': this.checkBody,
        'name': this.checkName,
        'email': this.checkEmail
      }
      for (let key in errors) {
        if (errors[key] === '' || errors[key] === null || errors[key] === undefined) {
          delete errors[key]
        }
      }
      return errors
    },
    valid: function () {
      return !Object.keys(this.errors).length
    }
  },
  props: ['showContent'],
  methods: {
    submit: async function () {
      const result = await this.send()
      this.result = result
      let toastOptions = {
        position: 'top-center',
        duration: 5000,
        fullWidth: true,
        className: 'toast'
      }
      if (result['status'] === 'success') {
        this.clear()
        this.updateContactCount()
        this.checkContactCount()

        this.$toasted.success(result['message'], toastOptions)
        this.closeModal()
      } else {
        this.$toasted.error(result['message'], toastOptions)
        this.closeModal()
      }
    },
    send: async function () {
      const url = '/api/contact'
      const params = {
        'type': this.type,
        'title': this.title,
        'body': this.body,
        'name': this.name,
        'email': this.email
      }
      try {
        return await axios
          .post(url, params)
          .then(function (res) {
            return res.data
          })
          .catch(function (error) {
            console.log(error)
          })
      } catch (error) {
        console.error(error)
      }
    },
    validTitle: function (title) {
      return title.length <= 20
    },
    validBody: function (body) {
      return body.length <= 1000
    },
    validEmail: function (email) {
      const re = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/
      return re.test(email)
    },
    clear: function () {
      this.title = ''
      this.body = ''
      this.name = ''
      this.email = ''
    },
    closeModal: function () {
      this.$emit('close')
      this.result = ''
    },
    ...mapActions(['updateContactCount', 'checkContactCount']),
    ...mapGetters(['canContact'])
  }
}
</script>

<style scoped>
ul {
  list-style-type: circle;
}
div, h2, ul, li {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
p {
  text-align: left;
  margin: 2px;
}
#overlay-info {
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.6);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}
#content {
  z-index:2;
  background-color: #F4EAE0;
  width: 100%;
  max-height: 640px;
  border: 2px solid;
  border-image: linear-gradient(to top, #877325, #C0B578);
  border-image-slice:1;
  text-align: left;
}
.btn {
  color: #FFFFFF;
  font-size: 20pt;
  background-color: #393836;
  padding: .3em .5em;
  text-align: center;
  cursor: pointer;
}
.btn:hover {
  cursor: pointer;
}
/* close button */
.action-close {
  position: relative;
  margin-top: 2em;
}
.action-close .btn {
  position: absolute;
  right: 0;
  top: -1em;
}
.contact {
  width: 100%;
  margin: 0 auto;
  overflow: auto;
  height: 640px;
}
.contact h2 {
  margin: 0 0 28px 0;
}
.contact-form table {
  width: 100%;
  margin: 0 0 28px 0;
  border-collapse: collapse;
}
.contact-form table tr {
  border-bottom: 2px solid #cccccc;
}
.contact-form table tbody tr th {
  width: 100%;
  padding: 4px;
  text-align: left;
  display: block;
}
.contact-form table tbody tr td {
  width: 100%;
  padding: 4px;
  text-align: left;
  display: block;
}
.contact-form table tbody tr td input {
  width: 100%;
  padding: 4px;
  box-sizing: border-box;
}
.contact-form .error {
  margin: 0;
  color: #ff0000;
  font-weight: bold;
  font-size: .85rem;
}
.contact-form button {
  display: block;
  width: 300px;
  padding: 10px 0;
  margin: 0 auto;
  color: #ffffff;
  border: 0;
  box-shadow: none;
  background-color: #384878;
  cursor: pointer;
}
.contact-form button:disabled {
  background-color: #a5a5a5;
}
.toast {
}

</style>



// WEBPACK FOOTER //
// src/components/ContactModalSm.vue